import React from "react";

const Hero = ({warehouse}) => {
    return (
        <React.Fragment>
            <div className="image-container">
                <img
                    src={require("../../assets/images/Willsmeet-Logo.png")}
                    alt="Company Logo"
                    className="card-image"
                />
            </div>
            <div className="details">
                <h3 className="fw-bolder">
                    Bansi Office Solutions Private Limited
                </h3>
                <p className="m-0">
                    {warehouse?.address?.addressLine1||"No. 1496, Opp. Park Square Apartment,"}
                </p>
                 <p className="m-0">
                    {warehouse?.address?.addressLine2||"19th Main, 1st Sector, HSR Layout"}
                </p>
                <p className="m-0">
                    {warehouse?.address?.city||"Bengaluru"} - {warehouse?.address?.pincode||"560102"}, {warehouse?.address?.state||"Karnataka"}
                </p>
                {warehouse?.gstIn&&<p className="m-0">GST IN : {warehouse?.gstIn}</p>}
                <p className="m-0">
                    Web: www.willsmeet.com, Email: {warehouse?.email||"sales@willsmeet.com"}
                </p>
            </div>
        </React.Fragment>
    )
}

export default Hero;